const tabWrapper = document.querySelector("#tabs-wrapper");
const tabsBtn = document.querySelectorAll("[data-tab]");
const tabsBtnWrapper = document.querySelector("#tabs-btn-wrapper");

const firstTabElement = document.querySelector(`#${tabsBtn[0].dataset.tab}`);
tabWrapper.style = `height: ${firstTabElement.clientHeight}px`;

tabsBtn.forEach((btn) => {
  btn.addEventListener("click", () => {
    document.querySelector(
      `[data-tab][data-active=true]`
    ).dataset.active = false;
    btn.dataset.active = true;
    const tab = document.querySelector(`#${btn.dataset.tab}`);
    const scrollOffset =
      tab.getBoundingClientRect().left -
      tabWrapper.getBoundingClientRect().left +
      tabWrapper.scrollLeft;
    tabWrapper.style = `height: ${tab.clientHeight}px`;
    tabWrapper.scrollTo({ behavior: "smooth", left: scrollOffset });
  });
});

tabsBtnWrapper.addEventListener("click", blockClickOnDrag, true);

tabsBtnWrapper.addEventListener("mousedown", (event) =>
  startDrag(event.pageX, tabsBtnWrapper)
);
tabsBtnWrapper.addEventListener("mousemove", (event) =>
  doDrag(event.pageX, tabsBtnWrapper)
);
tabsBtnWrapper.addEventListener("mouseup", () => stopDrag(tabsBtnWrapper));
tabsBtnWrapper.addEventListener("mouseleave", () => stopDrag(tabsBtnWrapper));

let isDragging = false;
let startX = 0;
let scrollStart = 0;
let hasMoved = false;
const dragThreshold = 5;

/**
 *
 * @param {number}         x
 * @param {HTMLDivElement} wrapper
 */
function startDrag(x, wrapper) {
  isDragging = true;
  hasMoved = false;
  startX = x;
  scrollStart = wrapper.scrollLeft;
  wrapper.dataset.isDragging = isDragging;
}

/**
 *
 * @param {number}         x
 * @param {HTMLDivElement} wrapper
 */
function doDrag(x, wrapper) {
  if (!isDragging) {
    return;
  }
  const dx = x - startX;
  if (Math.abs(dx) > dragThreshold) {
    hasMoved = true;
    wrapper.scrollLeft = (scrollStart - dx) * 1;
  }
}

/**
 *
 * @param {HTMLDivElement} wrapper
 */
function stopDrag(wrapper) {
  isDragging = false;
  wrapper.dataset.isDragging = isDragging;
}

/**
 *
 * @param {Event} event
 */
function blockClickOnDrag(event) {
  if (hasMoved) {
    event.preventDefault();
    event.stopPropagation();
  }
}
